// ABOUTME: Mounts user-analytics capture (page views, data-analytics clicks, queue) inside the router.
// ABOUTME: Renders the tracker only when the enableUserAnalytics setting is on.

import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { PropsWithChildren, useContext, useEffect } from 'react';

import { startAnalyticsQueue, stopAnalyticsQueue } from '../capture/analyticsQueue';
import { useActionTracking } from '../hooks/useActionTracking';
import { usePageViewTracking } from '../hooks/usePageViewTracking';

// The tracker mounts only when the flag is on: with it off nothing is attached and nothing is sent.
function AnalyticsTracker() {
    // Declared first so the queue is running before the first page view is enqueued.
    useEffect(() => {
        startAnalyticsQueue();
        return () => stopAnalyticsQueue();
    }, []);
    usePageViewTracking();
    useActionTracking();
    return null;
}

export function AnalyticsProvider({ children }: PropsWithChildren) {
    const { enableUserAnalytics } = useContext(SettingsContext);
    return (
        <>
            {enableUserAnalytics === true && <AnalyticsTracker />}
            {children}
        </>
    );
}
